export default __webpack_public_path__ + "static/media/finish-icon.03de5e06.png";